import React, { useEffect } from "react";
import { Hero } from "../../components";

function Attribution() {
  useEffect(() => {
    const handleMessage = (e: any) => {
      if (typeof e.data == "string") {
        console.log("Instance Of:", e.data);
        try {
          const { type, data } = JSON.parse(e.data);
          console.log("TYPE", type);

          if (type === "igem-attribution-form") {
            const element = document.getElementById("igem-attribution-form");
            console.log("DATA:", data);
            // @ts-ignore
            element.style.height = data + 50 + "px";
          }
        } catch (e) {}
      }
    };

    window.addEventListener("message", handleMessage);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col -z-10">
      <Hero title={"Attribution"}>
        "Gratitude is not only the greatest of virtues but {" "}
        <span className="text-lg font-black text-RougePastel md:text-xl lg:text-2xl">
          the parent of all others.
        </span>{" "}
        ." - Marcus Tullius Cicero
      </Hero>

      <div className="flex w-full px-[24px] md:px-[70px] py-[50px] justify-center items-center">
        <div
          className="flex justify-center items-center w-full flex-col md:max-w-[1500px] gap-[30px]"
          id="page-content"
        >
          <iframe
            style={{ width: "100%" }}
            id="igem-attribution-form"
            className="flex-auto shadow-md w-full"
            src="https://attributions.igem.org?team=ionis-paris&year=2023"
            title="Frame"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default Attribution;
